// start:ng42.barrel
export * from './submit-review.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/submit-review/submit-review/index.ts